import React, { useState, useEffect}  from 'react';
import { PostRequest } from 'components/common/index.js';
import { LogInRequired, LoggedInCanDownload, LoggedInPurchaseRequired, NeedsToConfirmEmail } from 'components/show_drawing/download_buttons/index.js';

const DownloadButtonsSection = ({}) => {
  const [mode, setMode] = useState('none');
  const [statusFetched, setStatusFetched] = useState(false);

  const [loggedIn, setLoggedIn] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [canDownload, setCanDownload] = useState(false);

  const [promptForCreateAccountEmail, setPromptForCreateAccountEmail] = useState('');

  const delayGetStatus = 500;

  const getStatus = () => {
    const timeOutId = setTimeout(getStatusAction, delayGetStatus);
    return () => clearTimeout(timeOutId);
  }

  const getStatusAction = () => {
    let data = {};
    if (window.currentDrawingOptions != undefined) {
      data = window.currentDrawingOptions;
      data.formula_options_present = true
    }

    PostRequest({
      url: '/download_button/status/' + window.drawing_id,
      data: data,
      302: () => {location.reload(true);},
      callback: ( data ) => {
        setLoggedIn( _prev => data.logged_in )
        setConfirmed( _prev => data.confirmed )
        setCanDownload( _prev => data.can_download )
        setStatusFetched( () => true );
        if(data.omniauth_sign_in_failed_account_does_not_exists) {
          setPromptForCreateAccountEmail(() => data.omniauth_email)
        }
      }
    })
  }

  useEffect( () => {
    let listen = 'show_drawing.downloads_buttons_refresh_required';
    document.addEventListener(listen, getStatus);
    return () => { document.removeEventListener(listen, getStatus);}
  }, [])

  useEffect(getStatus, [])

  if(!statusFetched) {
    return;
  }

  return (
    <div>
      {!loggedIn && (
        <div className="float-right">
          <LogInRequired mode={mode} setMode={setMode} promptForCreateAccountEmail={promptForCreateAccountEmail} callback={refreshDownloadButtons} />
        </div>
      )}

      {loggedIn && canDownload && (
        <div className="float-right">
          <LoggedInCanDownload />
        </div>
      )}

      {loggedIn && !canDownload && confirmed && (
        <div className="float-right">
          <LoggedInPurchaseRequired />
        </div>
      )}

      {loggedIn && !canDownload && !confirmed && (
        <div className="float-right">
          <NeedsToConfirmEmail onSuccess={refreshDownloadButtons} />
        </div>
      )}

    </div>
  )
}

export default DownloadButtonsSection;
